"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _bytes = require("bytes");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

var _useLocalize = _interopRequireDefault(require("../hooks/useLocalize"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ROOT_CSS = (0, _glamor.css)({
  display: 'flex',
  flexDirection: 'column'
});

var UploadAttachment = function UploadAttachment(_ref) {
  var _ref$activity = _ref.activity;
  _ref$activity = _ref$activity === void 0 ? {} : _ref$activity;
  var _ref$activity$attachm = _ref$activity.attachments,
      attachments = _ref$activity$attachm === void 0 ? [] : _ref$activity$attachm,
      _ref$activity$channel = _ref$activity.channelData;
  _ref$activity$channel = _ref$activity$channel === void 0 ? {} : _ref$activity$channel;
  var _ref$activity$channel2 = _ref$activity$channel.attachmentSizes,
      attachmentSizes = _ref$activity$channel2 === void 0 ? [] : _ref$activity$channel2,
      attachment = _ref.attachment;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      uploadAttachmentStyleSet = _useStyleSet2[0].uploadAttachment;

  var attachmentIndex = attachments.indexOf(attachment);
  var uploadLabel = (0, _useLocalize.default)('Upload file');
  var size = attachmentSizes[attachmentIndex];
  var formattedSize = typeof size === 'number' && (0, _bytes.format)(size);
  var uploadFileWithFileSizeLabel = (0, _useLocalize.default)('UploadFileWithFileSize', uploadLabel, attachment.name, formattedSize);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
    text: uploadFileWithFileSizeLabel
  }), _react.default.createElement("div", {
    "aria-hidden": true,
    className: (0, _classnames.default)(ROOT_CSS + '', uploadAttachmentStyleSet + '')
  }, _react.default.createElement("div", {
    className: "name"
  }, attachment.name), _react.default.createElement("div", {
    className: "size"
  }, formattedSize)));
};

UploadAttachment.propTypes = {
  activity: _propTypes.default.shape({
    attachment: _propTypes.default.array,
    channelData: _propTypes.default.shape({
      attachmentSizes: _propTypes.default.arrayOf(_propTypes.default.number)
    })
  }).isRequired,
  attachment: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = UploadAttachment;
exports.default = _default;